import { gql } from '@efficiently/client-core-graphql-models';

export const SET_APPROVAL_STATUS = gql(`
	mutation SetApprovalStatus($args: [SetApprovalStatusArgs!]!) {
		setApprovalStatus(args: $args)
	}
`);

export const SET_APPROVAL_STATUS_WITH_CASCADE = gql(`
	mutation SetApprovalStatusWithCascade($args: [SetApprovalStatusArgs!]!) {
		setApprovalStatusWithCascade(args: $args) {
			finishIds {
				_id
				status
			}
			finishes {
				_id
				status
			}
		}
	}
`);
